function n() {
  return navigator.language;
}

export { n as getLanguage };